<template>
  <div class="step__group" role="group" :aria-labelledby="`cs2-engineer-label${idx}`">
    <div class="step__group-cont">
      <div class="step__minititle step__minititle_flex mb0" :id="`cs2-engineer-label${idx}`">
        <span>Оборудование #{{ idx + 1 }}</span>
        <div @click="$store.commit('deleteEngineer', idx)" v-if="idx">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 5V13M10 5V13M1 3H15M6 1H10M3 3H13V15H3V3Z" stroke="#9496A1" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <TextInput :required="true" @setError="errors.name = $event" v-model="el.name"
        text="Наименование поврежденного/утраченного оборудования (производитель, модель)"
        :name="`damagedata-engineer${id}-name`" />
      <TextInput :required="true" @setError="errors.description = $event" v-model="el.description"
        text="Описание повреждений" :name="`damagedata-engineer${id}-description`" />
      <FileInput :forbiddenFileExts="extra.forbiddenFileExts" @fileExtsChange="setFileExts(0, $event)"
        :name="`damagedata-engineer${id}-files[]`" v-model="el.files" />
    </div>
  </div>

</template>
<script>
import TextInput from '@/components/inputs/TextInput.vue';
import FileInput from '@/components/inputs/FileInput.vue';
import { mapState } from 'vuex/dist/vuex.cjs.js';

export default {
  components: { TextInput, FileInput },
  data: () => ({
    errors: {},
    refreshKey: 0,
    modelValue: { type: Boolean, default: false }
  }),
  props: {
    id: { required: true },
    idx: { required: true },
  },
  methods: {
    setFileExts(index, array) {
      this.extra.fileExts['engineer' + this.id + '_' + index] = array
      this.refreshKey++
    },
  },
  computed: {
    ...mapState(['form', 'extra']),
    el() {
      return this.form.damagedata.engineer.find(el => el.id == this.id)
    },
    filled() {
      this.refreshKey;
      for (let key in this.errors)
        if (this.errors[key])
          return false
      for (let req of ['name', 'description'])
        if (!this.el[req])
          return false

      return true
    }
  },
  watch: {
    filled: {
      handler(v) {
        this.$emit('update:modelValue', v)
      },
      immediate: true
    }
  }

}
</script>
<style lang="sass">
</style>